/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiPublicQueueStreamQueryResponse, GetApiPublicQueueStreamQueryParams } from "../entities/GetApiPublicQueueStream";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getApiPublicQueueStream } from "../api/getApiPublicQueueStream";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getApiPublicQueueStreamQueryKey = (params: GetApiPublicQueueStreamQueryParams) => [{ url: '/api/public/queue/stream' }, ...(params ? [params] : [])] as const

export type GetApiPublicQueueStreamQueryKey = ReturnType<typeof getApiPublicQueueStreamQueryKey>

export function getApiPublicQueueStreamQueryOptions(params: GetApiPublicQueueStreamQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getApiPublicQueueStreamQueryKey(params)
        return queryOptions<GetApiPublicQueueStreamQueryResponse, ResponseErrorConfig<Error>, GetApiPublicQueueStreamQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getApiPublicQueueStream(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Server-Sent Events для real-time обновлений очереди
 * @summary SSE поток для экрана очереди
 * {@link /api/public/queue/stream}
 */
export function useGetApiPublicQueueStream<TData = GetApiPublicQueueStreamQueryResponse, TQueryData = GetApiPublicQueueStreamQueryResponse, TQueryKey extends QueryKey = GetApiPublicQueueStreamQueryKey>(params: GetApiPublicQueueStreamQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetApiPublicQueueStreamQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getApiPublicQueueStreamQueryKey(params)
         

         const query = useQuery({
          ...getApiPublicQueueStreamQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}